module.exports = __webpack_public_path__ + "media/images/jumping/promo-felicidad-section-m-9ec78d4899e5a315b96ffe3d8d755109.jpg";